<section class="sg-documents-container ml-3"  >
  <div class="row mx-0 margin-top-bottom mt-3">
    <div class="col-6">
      <h4 class="sg-page-title"> Shared Documents</h4>
    </div>
  </div>
</section>

<div class="search-toggle"  [ngClass]="isOpenDrawer ? 'clickEventdisabled' : ''">
  <div class="folder-icon">
    <button (click)="selectedToggle('Folders')" class="supplier-toggle-button" [class.folderActive]="folderToggleFlag">
      <mat-icon *ngIf="folderIcon">folder_open</mat-icon>
      <span class="toggleText">Folders</span>
    </button>
    <button (click)="searchToggle('Search')" class="supplier-toggle-button" [class.searchActive]="searchToggleFlag">
      <mat-icon *ngIf="searchIcon">search</mat-icon>
      <span class="toggleText">Search</span>
    </button>
  </div>
</div>
  
<mat-drawer-container [hasBackdrop]="false" autosize class="sg-main supplier-container">
  <section class="sg-documents-container " [ngClass]="isOpenDrawer ? 'clickEventdisabled' : ''" >
    <section [ngClass]="foldersGrid && !searchGrid? 'd-block' : 'd-none'">
      <div class="row mx-0 align-items-end select-arrow-align"  >
        <div class="col-3"   [ngClass]="!isUserSupplier ? 'd-block' : 'd-none'" >
          <form [formGroup]="suppliersForm" class="share-document-folder-input-placeholder" autocomplete="off">
            <label class="sg-supllier-number">{{supplierDetails?.organizationCode}}</label>
            
            <!-- <mat-select placeholder="Select Supplier" formControlName="supplier" name="item" class="sg-select-sup document-select-supplier" (selectionChange) ="onChangeSupplier($event.value.id)" > -->
            <mat-select placeholder="Select Supplier" formControlName="supplier" name="item" class="sg-select-sup document-select-supplier" >
                <input matInput class="search-box" formControlName="searchBox" placeholder="Search by Supplier Name, Supplier Code">
              <mat-option *ngFor="let item of supplierResults" [value]="item" [selected]='true' >
                  {{item.supplierName}} <span class="sg-supplier-code">{{item.organizationCode}}</span>
              </mat-option>
            </mat-select>   
          
          </form>
        </div>
        <div class="col-3"  [ngClass]="isUserSupplier ? 'd-block' : 'd-none'">
          <label class="sg-supllier-number">{{supplierDetails?.organizationCode}}</label>
          <h4 class="font-weight-normal">{{supplierDetails?.supplierName}}</h4>
        </div>
        <div class="col-3">
          <button  mat-raised-button class="mat-raised-button mat-primary sg-icon-button" (click)="openDrawerHandler($event)" >
            <mat-icon class="sg-fileupload-icon">file_upload</mat-icon><span>Upload</span>
          </button>
        </div>
      </div>
      <app-folders-view *ngIf="foldersGrid && gridShowHide && !searchGrid || isUserSupplier " (uploadForm)="openDrawerHandler($event)"
        (editFormHandler)="editFormHandler($event)"  [supplierDetails]="supplierDetails">
      </app-folders-view>
    </section>
    <app-document-search-grid *ngIf="searchGrid"  (editFormHandler)="editFormHandler($event)" [supplierDetails]="supplierDetails" [refreshDocumentSearchGrid]="refreshDocumentSearchGrid"></app-document-search-grid>
  </section>
  <mat-drawer #drawer  class="file-upload d-flex"
    mode="over" [(opened)]="isOpenDrawer" position="end" id="sg-drawer-open"
    [style.top]="environmentName && environmentName !== 'PRODUCTION' ? '84px' : ''">
    <div class="sg-upload-container-fluid">
      <div class="row mx-0">
        <div class="sg-upload-header col-12 px-0">
          <div class="row mx-0 sg-box-style align-items-center" *ngIf="editUploadedfile">
            <span class="material-icons edit_details_icon"  > mode_edit</span>  Details <span class="material-icons postion-right" (click)="drawerCloseHandler()">
              cancel
            </span>
          </div>
          <div class="row mx-0 sg-box-style align-items-center" *ngIf="!editUploadedfile">
            <mat-icon class="sg-upload-icon d-flex align-items-center">file_upload </mat-icon>
            Upload
          </div>
        </div>
      </div>
      <div class="row mx-2 pl-1">
        <div class="sg-upload-body w-100 col-11 px-0 " style="top: 50px;">
          <div class="row mx-1 mt-2 sg-form-field-label w-100">
            Supplier <span class="sg-form-field-required-marker ml-1">*</span>
            <span class="sg-infoicon">
              <p class="material-icons-outlined" [tooltip]="template" contentType="template" [options]="tooltipOptions"
                tooltipClass="tooltip-feedback">help_outline</p>
                <ng-template #template class="w-100">
                  <div class="row mx-0 w-100" >
                    <div class="col-12 w-100 px-0">
                      <p>Search and select Supplier from the list</p>
                    </div>
                  </div>
                </ng-template>
            </span>
          </div>
          <div class="row mx-1"  [ngClass]="isUserSupplier ? 'd-block' : 'd-none'">
            {{supplierDetails?.supplierName}} [{{supplierDetails?.organizationCode}}]
          </div>
          <form [formGroup]="uploadFileForm">
            <app-upload-documents 
              (changeHandler)="parentEventHandlerFunction($event)" 
              (tagsHandler)="onTagsEventHandler($event)"
              (docTypeSelected)="ondocTypeSelected($event)"
              [foldersGrid]="foldersGrid"
              [editUploadedfile]="editUploadedfile"
              [isUserSupplier]="isUserSupplier" [suppliers]="allSuppliers" 
              [breadCrumb]="breadCrumb" [supplierInfo]="supplierDetails">
            </app-upload-documents>
          </form>
        </div>
      </div>
      <div class="row mx-0 sg-footer-container d-flex">
        <div class="sg-boxStyle">
          <div class="row">
            <div class="col-5">
              <div *ngIf="showDeleteBtn">
                <button class="sg-primary-stroked mat-stroked-button ml-2" *ngIf="editUploadedfile" (click)="deleteDocumentHandler()">Delete</button>
              </div>
            </div>
            <div class="sg-boxStyle-btn col-7">
              <button mat-raised-button class="mat-raised-button mat-primary sg-primary-button ml-2 sg-upload-button rep-action-button rep-btn-margin"
              *ngIf="editUploadedfile"
                [disabled]="editUploadedfile ? !uploadFileForm.dirty || uploadFileForm.invalid : uploadFileForm.invalid" 
                (click)="editUploadFileHandler()">Save</button>
              <button mat-raised-button class="mat-raised-button mat-primary sg-primary-button ml-2 sg-upload-button" *ngIf="!editUploadedfile"
                [disabled]="!uploadFileForm.dirty || uploadFileForm.invalid || uploadDocumentsComponent?.isDocTypeLoading" (click)="uploadFileHandler()">Upload</button>
              <button class="sg-primary-stroked mat-stroked-button ml-4" (click)="drawerCloseHandler()">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-drawer>
</mat-drawer-container>
<div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData && !isUploading">
  <mat-spinner></mat-spinner>
</div>
<div class="sg-upload-progress-overlay" *ngIf="isUploading">
  <div class="sg-upload-progress-container">
    <div class="sg-upload-progress-label">Uploading... {{ uploadProgress }}%</div>
    <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
  </div>
</div>



